export default __webpack_public_path__ + "static/11-min-f754c6aa1eabd8e0bf12d355dcdf6c4a.png";